import { Box, Dialog, DialogContent, Stack, styled, Typography, TypographyProps } from '@mui/material';
import { EColors, getColor } from 'theme';

type PrimaryDialogProps = {
    width?: string;
    height?: string;
    padding?: string;
};

export const PrimaryDialog = styled(Dialog, {
    shouldForwardProp: prop => prop !== 'width' && prop !== 'height' && prop !== 'padding',
})<PrimaryDialogProps>(({ theme, width = 'calc(100% - 80px)', height = 'calc(100% - 80px)', padding = '0px' }) => ({
    '& .MuiDialog-paper': {
        boxSizing: 'border-box',
        borderRadius: '12px',
        width: width,
        height: height,
        maxWidth: '1400px',
        maxHeight: 'none',
        padding: padding ? padding : '0px',
    },
    '& .MuiBackdrop-root': {
        backdropFilter: 'blur(12px)',
        backgroundColor: 'rgba(30, 30, 30, 0.44)',
    },
    // On phones: stretch edge-to-edge with no border radius, matching fullScreen UX.
    [theme.breakpoints.down('sm')]: {
        '& .MuiDialog-paper': {
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
            margin: 0,
            borderRadius: 0,
        },
    },
}));

export const PrimaryDialogContent = styled(DialogContent)({
    '&.MuiDialogContent-root': {
        boxSizing: 'border-box',
        justifyContent: 'flex-start',
        gap: 12,
        backgroundColor: getColor(EColors.pureWhite),
    },
});

export const PrimaryDialogHeader = styled(Box)(({ theme }) => ({
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(3),
    position: 'absolute',
    width: `calc(100% - ${theme.spacing(6)})`,
    top: 0,
    left: theme.spacing(3),
    paddingBottom: 0,
    backgroundColor: getColor(EColors.pureWhite, 0.53),
    WebkitBackdropFilter: 'blur(8px)',
    backdropFilter: 'blur(12px)',
    zIndex: 2,
}));

export const PrimaryDialogBody = styled(Stack)({
    maxWidth: 480,
    margin: '0 auto',
    marginTop: '52px',
    marginBottom: 46,
    gap: 24,
});

export const PrimaryDialogFooter = styled(Box)(({ theme }) => ({
    position: 'absolute',
    width: `calc(100% - ${theme.spacing(6)})`,
    height: theme.spacing(8),
    bottom: 0,
    left: theme.spacing(3),
    backgroundColor: getColor(EColors.pureWhite, 0.53),
    WebkitBackdropFilter: 'blur(8px)',
    backdropFilter: 'blur(16px)',
    zIndex: 1,
}));

export const PrimaryDialogTitle = styled(Typography)<TypographyProps>({
    fontSize: '32px',
    fontWeight: 700,
    textAlign: 'center',
    fontFamily: '"Switzer", Roboto, Inter, -apple-system, BlinkMacSystemFont, sans-serif',
    color: getColor(EColors.v3TextPrimary),
});

export const PrimaryDialogSubtitle = styled(Typography)<TypographyProps>({
    fontWeight: 500,
    textAlign: 'center',
    color: getColor(EColors.v3TextSecondary),
    fontFamily: '"General Sans"',
    marginBottom: '24px',
});
